import {Callout, CalloutType} from "./Callout";

export default Callout;
export {Callout, CalloutType};